export default "__VITE_ASSET__C3jYP2lK__"